import { ChartFacade } from '@mode/charts/contract';
import { CompiledField } from '@mode/shared/util-switch';
import { DomainLoader } from './colors-modal.component';

export class ErrorDomainLoader implements DomainLoader {
  fetchDomain(
    chartFacade: ChartFacade,
    currentField: CompiledField,
    onResult: (result: any[]) => void,
    onError: (error: string) => void
  ): void {
    onError('Unable to load field values');
  }
}
